import request from '@/utils/request'

export interface SkuFeature {
  id: number
  featureId: number
  featureKey: string
  featureName: string
  durationType: string
  durationValue?: number
  isActive: boolean
}

export interface Sku {
  id: number
  skuCode: string
  name: string
  description?: string
  productType: string
  isActive: boolean
  metadata?: any
  features: SkuFeature[]
  createdAt: Date
  updatedAt: Date
}

export interface Feature {
  id: number
  featureKey: string
  name: string
  description?: string
}

// SKU CRUD
export const listSkus = (params: any) =>
  request({
    url: '/skus',
    method: 'get',
    params
  })

export const getSkuById = (id: number) =>
  request({
    url: `/skus/${id}`,
    method: 'get'
  })

export const getSkuByCode = (code: string) =>
  request({
    url: `/skus/code/${code}`,
    method: 'get'
  })

export const createSku = (data: any) =>
  request({
    url: '/skus',
    method: 'post',
    data
  })

export const updateSku = (id: number, data: any) =>
  request({
    url: `/skus/${id}`,
    method: 'put',
    data
  })

export const deleteSku = (id: number) =>
  request({
    url: `/skus/${id}`,
    method: 'delete'
  })

// SKU Features
export const addFeatureToSku = (skuId: number, data: any) =>
  request({
    url: `/skus/${skuId}/features`,
    method: 'post',
    data
  })

export const updateSkuFeature = (skuId: number, featureId: number, data: any) =>
  request({
    url: `/skus/${skuId}/features/${featureId}`,
    method: 'put',
    data
  })

export const removeFeatureFromSku = (skuId: number, featureId: number) =>
  request({
    url: `/skus/${skuId}/features/${featureId}`,
    method: 'delete'
  })

// Available Features
export const getAvailableFeatures = () =>
  request({
    url: '/skus/available-features',
    method: 'get'
  })
